var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoneArbre(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 17 17",
    style: {
      enableBackground: "new 0 0 17 17"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.strzonea0{fill:#605F71;}\r\n\t.strzonea1{fill:#FFFFFF;}\r\n\t.strzonea2{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.strzonea3{fill:#FFFFFF;stroke:#FFFFFF;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_1"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 2.4,
    className: "strzonea0",
    width: 5.2,
    height: 14.6
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "strzonea0",
    points: "2.6,0.1 0,2.1 5.2,2.1  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.8,
    className: "strzonea0",
    width: 4.2,
    height: 17
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 2.4,
    className: "strzonea0",
    width: 10.7,
    height: 14.6
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Calque_3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.1,
    y: 2.4,
    className: "strzonea1",
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.1,
    y: 5.8,
    className: "strzonea1",
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.1,
    y: 12.9,
    className: "strzonea1",
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.1,
    y: 9.3,
    className: "strzonea1",
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 16.5,
    className: "strzonea1",
    width: 17,
    height: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "strzonea2",
    x1: 12.5,
    y1: 9.8,
    x2: 1.2,
    y2: 9.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "strzonea2",
    x1: 6.9,
    y1: 15.4,
    x2: 6.9,
    y2: 4.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "strzonea3",
    cx: 6.9,
    cy: 9.8,
    rx: 4,
    ry: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoneArbre);
export default __webpack_public_path__ + "static/media/Zone-arbre.2202e8b4b06288b56ca59847aa4e6c90.svg";
export { ForwardRef as ReactComponent };